<template>
  <div class="menuFrame">
    <loading :active.sync="isLoading"></loading>

    <div id="track">
      <div class="d-flex justify-content-between">
        <div>
          <a href="/ExhibitorServiceTW/en">Exhibition List</a><span>/</span>
          <em name="Exhibition"></em> <span>/</span>Fascia Entry
        </div>
        <div>
          <span class="bold">Account :</span>
          <span> {{ UserId }}</span>
        </div>
      </div>
    </div>

    <div class="MbDevice">
      <div class="homeLeft mt-5">
        <div class="UserAccount ml-1">
          <span class="bold">Account :</span>
          <span> {{ UserId }}</span>
        </div>
        <hr />
        <div class="expoLogo"><img :src="ExhLogo" width="100%" /></div>
        <div class="expoInfo">
          <p class="bold" name="Exhibition"></p>
          <p>{{ ExhBegin }} - {{ ExhEnd }}</p>
          <p>{{ eExhVenue }}</p>
        </div>
        <p class="clear"></p>
      </div>
    </div>
    <!-- track end -->
    <!-- article -->
    <div class="articleEn">
      <div>
        <Dashboard></Dashboard>

        <div class="contentBox">
          <h1>Fascia Entry</h1>
          <p class="my-3">&nbsp;</p>

          <div v-if="FasciaArchived">
            <div class="alert text-dark alert-light mb-5" role="alert">
              <div class="font-weight-bold">Notice:</div>
              <ol class="ml-4">
                <li>
                  Each 9 sqm shell scheme booth can get 1 company name board
                  free of charge.
                </li>
                <li>This form is for shell scheme booth use only.</li>
                <li>
                  All items ordered are on a rental basis and exhibitors will
                  have to take responsibility for any damages or losses.
                </li>
                <li>
                  The Fascia Name will be the same as the company name of
                  application form if you do not return this form by
                  <span class="red">{{ FasciaDeadline }}</span
                  >. If you request to change the fascia name after the
                  deadline, the price will be USD30/pcs.
                </li>
                <li>
                  If you have any problems regarding installation, you must
                  contact us 1 week before the exhibition commences.
                </li>
              </ol>
            </div>

            <p class="my-3">&nbsp;</p>

            <p class="formTitle">Fascia Name <span class="red">*</span></p>
            <div v-if="DeadlinePassed" class="mt-2">
              {{ FasciaName }}
            </div>
            <div v-else-if="!DeadlinePassed">
              <form @submit.prevent="submitFascia">
                <div class="langTip">
                  <input
                    type="text"
                    name="eNewsTopic"
                    class="maxText textStyle"
                    maxlength="45"
                    v-model="FasciaName"
                    @input="filterEnglishOnly"
                    @compositionstart="isComposing = true"
                    @compositionend="handleCompositionEnd"
                  />
                  <span>EN</span>
                </div>
                <div id="error1"></div>

                <div class="mt-2 grayBG">
                  *Please enter the exact Exhibiting Company Name below. (max.
                  45 characters, including blanks and punctuation marks)
                </div>
                <div class="text-center">
                  <button type="submit" class="btn btn-primary mt-4 btn-lg">
                    Submit
                  </button>
                </div>
              </form>
            </div>
          </div>

          <div v-else>
            <p class="mt-4">*Fascia application is currently not open</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import axios from "axios";
import Dashboard from "@/components/Dashboard_en.vue";

export default {
  components: {
    Dashboard,
  },
  metaInfo() {
    return {
      title: `Fascia Entry - Chan Chao Exhibitor's Online Service System`,
    };
  },

  data() {
    return {
      UserId: "",
      RegNo: "",

      CSRF_Token: "",

      lang: "en",

      //判斷各頁狀態儀表版值
      OnlineExpolayoutStatus: "",
      PressReleaseStatus: "",
      VideoStatus: "",
      ProductStatus: "",
      BasicinformationStatus: "",
      FasciaStatus: "",
      BadgeStatus: "",

      //判斷儀表板是否有線上展
      HasOnlineExpo: "",
      openOnlineExpo: "",
      showOnlineStatus: false,

      ExhLogo: "",
      ExhBegin: "",
      ExhEnd: "",
      ExhVenue: "",
      eExhVenue: "",

      FasciaName: "",
      DeadlinePassed: true,
      FasciaData: {},
      isComposing: false,
      FasciaArchived: true,

      FasciaDeadline: "",
    };
  },

  watch: {},

  methods: {
    // filterEnglishOnly(e) {
    //   // 僅保留英文大小寫和空格
    //   const englishOnly = e.target.value.replace(
    //     /[^A-Za-z0-9\s<>&%$()_=@!?.,:;'"\-+*#\/]/g,
    //     ""
    //   );
    //   this.FasciaName = englishOnly;
    // },

    // filterEnglishOnly(e) {
    //   if (this.isComposing) return; // 注音輸入中，暫停處理
    //   this.FasciaName = e.target.value.replace(
    //     /[^A-Za-z0-9\s<>&%$()_=@!?.,:;'"\-+*#\/]/g,
    //     ""
    //   );
    // },

    filterEnglishOnly(e) {
      if (this.isComposing) return; // 注音輸入中，暫停處理
      const filteredValue = e.target.value
        .replace(/[^a-zA-Z0-9 $*^!@#&()+%,./-]/g, "") // 只允許英文、數字、空格及指定特殊符號
        .toUpperCase();
      this.FasciaName = filteredValue;
      e.target.value = filteredValue; // 同步更新輸入框
    },
    handleCompositionEnd(e) {
      this.isComposing = false;
      const filteredValue = e.target.value
        .replace(/[^a-zA-Z0-9 $*^!@#&()+%,./-]/g, "") // 只允許英文、數字、空格及指定特殊符號
        .toUpperCase();
      this.FasciaName = filteredValue;
      e.target.value = filteredValue; // 同步更新輸入框
    },

    submitFascia() {
      const vm = this;

      if (vm.FasciaName == "") {
        $("#error1").html(
          "<span class='errorTextArea'>This field is required.</span>"
        );
        return;
      } else {
        let url = `https://www.chanchao.com.tw/apiExhibitors/Fascia`;

        const info = {
          RegNo: vm.RegNo,
          FasciaName: vm.FasciaName,
          CSRF: vm.CSRF_Token,
        };

        axios
          .post(url, info)
          .then((response) => {
            if (response.data.Code == 200) {
              alert("Fascia Name updated successfully.");
              location.reload();
            } else {
              alert("Failed to update Fascia Name.");
            }
          })
          .catch((error) => {
            console.error("Error updating Fascia Name:", error);
          });
      }
    },
  },

  created() {
    const vm = this;

    axios
      .get("https://www.chanchao.com.tw/apiExhibitors/CSRF_Token")
      .then((response) => {
        vm.CSRF_Token = response.data;
      });

    axios
      .get(`https://www.chanchao.com.tw/apiExhibitors/UserID`)
      .then((response) => {
        vm.UserId = response.data;
      });

    //url取出展碼
    let currentUrl = location.href;
    vm.RegNo = currentUrl.split("no=")[1].split("&")[0];

    axios
      .get(
        `https://www.chanchao.com.tw/apiExhibitors/Exhibition/${vm.RegNo}?lang=${vm.lang}`
      )
      .then((response) => {
        let FasciaArchived = response.data.Data.ES_Fascia_Archived;
        vm.FasciaDeadline = response.data.Data.ES_Fascia_Deadline;

        if (FasciaArchived == 0) {
          vm.FasciaArchived = false;
        } else {
          vm.FasciaArchived = true;
          //取得時間
          let today = new Date();
          today.setHours(0, 0, 0, 0);

          let deadlineStr = vm.FasciaDeadline.replace(/\//g, "-"); // 轉成安全格式
          let deadline = new Date(deadlineStr);
          deadline.setHours(0, 0, 0, 0);

          if (today > deadline) {
            vm.DeadlinePassed = true; // 如果今天日期大於截止日期，則DeadlinePassed為true
          } else {
            vm.DeadlinePassed = false; // 否則為false
          }
        }
      });

    axios
      .get(`https://www.chanchao.com.tw/apiExhibitors/Fascia/${vm.RegNo}`)
      .then((response) => {
        if (response.data.Code == 404) {
        } else {
          vm.FasciaData = response.data.Data;
          vm.FasciaName = vm.FasciaData.FasciaName;

          let GetFasciaArchived = true;
          GetFasciaArchived = vm.FasciaData.Archived;

          if (GetFasciaArchived) {
            vm.FasciaArchived = true;
            //取得時間
            let today = new Date();
            today.setHours(0, 0, 0, 0);

            let deadlineStr = vm.FasciaData.Deadline.replace(/\//g, "-"); // 轉成安全格式
            let deadline = new Date(deadlineStr);
            deadline.setHours(0, 0, 0, 0);

            if (today > deadline) {
              vm.DeadlinePassed = true; // 如果今天日期大於截止日期，則DeadlinePassed為true
            } else {
              vm.DeadlinePassed = false; // 否則為false
            }
          } else {
            vm.FasciaArchived = false;
          }
        }
      });
  },
};
</script>

<style lang="scss">
.grayBG {
  background: #fff7dd;
  color: #333;
  padding: 2px 8px;
  display: inline-block;
  word-break: break-all;
  font-size: 14px;
}

.list-group-item {
  padding: 0.1rem 0.2rem;
}

.table th,
.table td {
  text-align: center;
  vertical-align: middle !important;
}

@media screen and (min-width: 576px) {
  lite-youtube {
    width: 320px;
    height: 180px;
    cursor: pointer;
  }
}

.topUK {
  position: relative;
}

.insideUK {
  position: absolute;
  top: 0;
  right: 0;
  background-color: rgba(162, 166, 167, 0.411);
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.uncomplete {
  background-image: url("../../assets/images/tickGray.svg");
  width: 18px;
  height: 18px;
  display: inline-block;
  background-repeat: no-repeat;
  background-position: left center;
  background-size: auto 100%;
  padding-left: 20px;
}

.complete {
  background-image: url("../../assets/images/tick.svg");
  width: 18px;
  height: 18px;
  display: inline-block;
  background-repeat: no-repeat;
  background-position: left center;
  background-size: auto 100%;
  padding-left: 20px;
}
</style>
